import { useAppDispatch } from "Hook/hooks";
import { useEffect, useState } from "react";
import { Button, Container, Form } from "react-bootstrap";
import { setToast } from "../../Redux/Ducks/toastSlice"; // adjust path if needed
import { loginUser } from "../../Redux/Ducks/userSlice";
import { Helmet } from "react-helmet";

interface IModel {
  email: string;
}

export default function Login() {
  const [model, setModel] = useState<IModel>({ email: "" });
  const dispatch = useAppDispatch();

  useEffect(() => {
    const savedEmail = localStorage.getItem("loginEmail");
    if (savedEmail) {
      setModel({ email: savedEmail });
    }
  }, []);

  const validateEmail = (email: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const onChange = (fieldId: string, value: any) => {
    setModel({ ...model, [fieldId]: value });
  };

  const signIn = () => {
    if (!validateEmail(model.email)) {
      dispatch(
        setToast({
          message: "Invalid email format. Please enter a valid email address.",
          type: "error",
        }),
      );
      return;
    }

    localStorage.setItem("loginEmail", model.email);
    dispatch(loginUser(model));
  };

  return (
    <Container fluid className="login-container">
      <Helmet>
        <title>
          Foodslift POS Login | Sign in to Foodslift POS to manage orders,
          kitchen and reports for your restaurant.
        </title>
        <meta
          name="description"
          content="Sign in to Foodslift POS to manage orders, kitchen and reports for
your restaurant."
        />
      </Helmet>
      <div className="bg-wrapper" />

      <div className="login-card">
        <div className="login-logo">
          <img
            src="/01-login-page-logo.png"
            alt="Foodslift"
            className="rounded"
          />
        </div>

        <div className="login-text">
          <h2>Welcome back</h2>
          <p>Enter your email to receive a code in your inbox</p>
        </div>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            signIn();
          }}
          className="login-form"
        >
          <Form.Group className="mb-3">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="email"
              placeholder="you@restaurant.com"
              value={model.email}
              onChange={(e) => onChange("email", e.target.value)}
            />
          </Form.Group>

          <Button variant="primary" type="submit" className="login-btn">
            Continue
          </Button>
        </Form>
      </div>

      <div className="footer">© 2026 Foodslift. All rights reserved.</div>
    </Container>
  );
}
